import { useEffect, useState } from "react";

// Api
import { GetSeriesFeed } from "../../../../Api/Series"; // adjust path

// Models
import type ICarouselContentDTO from "../../../../Models/DTOs/ICarouselContentDTO";
import type SeriesDTO from "../../../../Models/DTOs/SeriesDTO";

// Helpers
import { transformSeriesToCarouselContent } from "../../../../Helpers/DataConversion/ConvertToCarouselContentItem";

function useFetchSeriesList(
    take: number,
    skip: number,
    shouldAppendData: boolean
) {
    const [series, setSeries] = useState<ICarouselContentDTO[]>([]);
    const [seriesLoading, setSeriesLoading] = useState(false);
    const [seriesError, setSeriesError] = useState("");

    useEffect(() => {
        const controller = new AbortController();

        setSeriesLoading(true);
        setSeriesError("");

        (async () => {
            try {
                const data = await GetSeriesFeed({
                    take,
                    skip,
                    order: "desc",
                    signal: controller.signal,
                }); // CountWrapper<SeriesDTO>

                const transformed = (data.items ?? []).map((s: SeriesDTO) =>
                    transformSeriesToCarouselContent(s)
                );

                if (shouldAppendData) {
                    setSeries((prev) => [...prev, ...transformed]);
                } else {
                    setSeries(transformed);
                }
            } catch (err: any) {
                // ignore intentional cancels
                if (err?.name === "CanceledError") return;

                console.error(err);
                setSeriesError("Failed to fetch series.");
            } finally {
                setSeriesLoading(false);
            }
        })();

        return () => controller.abort();
    }, [take, skip, shouldAppendData]);

    return { series, seriesLoading, seriesError };
}

export default useFetchSeriesList;
